import { useEffect } from 'react';

import { MixpanelEvents } from '@/shared/thirdParty/mixpanel';

import { useArmRecordingWelcomeSurvey } from '../../model/useArmRecordingWelcomeSurvey';
import { useRecordingWelcomeSurveyStore } from '../../model/useRecordingWelcomeSurveyStore';
import { RecordingWelcomeSurveyModal } from '../RecordingWelcomeSurveyModal';

export const RecordingWelcomeSurveyMount = () => {
  useArmRecordingWelcomeSurvey();
  const isOpen = useRecordingWelcomeSurveyStore((s) => s.isOpen);

  useEffect(() => {
    if (isOpen) MixpanelEvents.recordingWelcomeSurveyShown();
  }, [isOpen]);

  return <RecordingWelcomeSurveyModal />;
};
